import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { formatDate, formatViews } from '@/utils/format';

interface ArticleAsideProps {
  headings: { index: number; text: string }[];
  related: Article[];
}

export default function ArticleAside({ headings, related }: ArticleAsideProps) {
  return (
    <aside className="lg:col-span-4">
      <div className="lg:sticky lg:top-32 space-y-6">
        {headings.length > 0 && (
          <nav aria-label="本文目录" className="rounded-lg border border-background-200/80 bg-background-100 p-5">
            <h2 className="font-heading text-sm font-bold text-foreground-950">本文目录</h2>
            <ol className="mt-3 space-y-2">
              {headings.map((item, i) => (
                <li key={item.index}>
                  <a
                    href={`#sec-${item.index}`}
                    className="flex gap-2 text-xs text-foreground-600 hover:text-primary-600 transition-colors leading-relaxed"
                  >
                    <span className="text-primary-500 font-medium shrink-0">{String(i + 1).padStart(2, '0')}</span>
                    <span>{item.text}</span>
                  </a>
                </li>
              ))}
            </ol>
          </nav>
        )}

        <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
          <h2 className="font-heading text-sm font-bold text-foreground-950">相关推荐</h2>
          <ul className="mt-3 space-y-4">
            {related.map((article) => (
              <li key={article.id} className="flex gap-3">
                <Link to={`/article/${article.slug}`} className="shrink-0 w-16 h-14 rounded-md overflow-hidden">
                  <img src={article.cover} alt={article.title} className="w-full h-full object-cover object-top" />
                </Link>
                <div className="min-w-0">
                  <h3 className="text-xs font-bold text-foreground-900 leading-snug line-clamp-2">
                    <Link to={`/article/${article.slug}`} className="hover:text-primary-600 transition-colors">
                      {article.title}
                    </Link>
                  </h3>
                  <p className="mt-1 text-[11px] text-foreground-500">
                    {formatDate(article.date)} · {formatViews(article.views)} 阅读
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-lg bg-secondary-950 text-background-100 p-5">
          <span className="flex items-center gap-1.5 text-xs text-accent-400">
            <i className="ri-mail-send-line" />
            线报订阅
          </span>
          <p className="mt-2 text-sm text-background-200 leading-relaxed">
            每周一封整理信，跟进你错过的后续反映。
          </p>
          <Link
            to="/#subscribe"
            className="mt-4 inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            立即订阅
          </Link>
        </div>
      </div>
    </aside>
  );
}

